import type {
  GridProps} from '@chakra-ui/react'
import {
  Button,
  Flex,
  forwardRef,
  Grid,
  Link,
  Text,
} from '@chakra-ui/react'

import type { Document } from '../../data/documents'

export interface DocumentsSectionHeaderProps extends GridProps {
  title: string
  lastDownloadedAll?: string
  mergedDoc?: Document
}

export const DocumentsSectionHeader = forwardRef(
  (
    {
      children,
      title,
      lastDownloadedAll,
      sx,
      mergedDoc,
      ...rest
    }: DocumentsSectionHeaderProps,
    ref,
  ) => {
    return (
      <Grid
        ref={ref}
        sx={{
          gap: 2,
          ...sx,
        }}
        {...rest}
      >
        <Text sx={{ fontSize: 'sm', fontWeight: 'bold' }}>{title}</Text>

        <Flex sx={{ gap: 6 }}>
          {mergedDoc?.url && <Button as={Link} href={mergedDoc.url} target='_blank' variant="link">stáhnout vše</Button>}

          {lastDownloadedAll && (
            <Text sx={{ fontSize: 'sm' }}>
              Naposledy staženo: {lastDownloadedAll}
            </Text>
          )}
        </Flex>

        {children}
      </Grid>
    )
  },
)
